import React from "react";
import PropTypes from "prop-types";

const Heading3 = (props) => {
  const { text, id: id } = props.config;
  return (
    <React.Fragment>
      <h3 id={id} className={props.config.class}>
        {text}
      </h3>
    </React.Fragment>
  );
};

Heading3.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Heading3;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Heading3.js